import { Fragment, type ReactNode } from "react";
import { Link } from "react-router";
import { Icon } from "../Icon";

export interface Crumb { label: ReactNode; to?: string }

export function PageHeader({ title, subtitle, breadcrumbs, actions, meta, badge }: {
  title: ReactNode; subtitle?: ReactNode; breadcrumbs?: Crumb[]; actions?: ReactNode;
  /** Row of badges / facts under the title (language, level, status…). */
  meta?: ReactNode;
  /** Shown next to the title (e.g. the status badge). */
  badge?: ReactNode;
}) {
  return (
    <div className="page-header">
      <div className="page-header-text">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="breadcrumbs">
            {breadcrumbs.map((c, i) => (
              <Fragment key={i}>
                {i > 0 && <Icon name="chevronRight" size={14} />}
                {c.to ? <Link to={c.to}>{c.label}</Link> : <span aria-current={i === breadcrumbs.length - 1 ? "page" : undefined}>{c.label}</span>}
              </Fragment>
            ))}
          </nav>
        )}
        <div className="page-header-title">
          <h1>{title}</h1>
          {badge}
        </div>
        {subtitle && <p className="page-header-sub">{subtitle}</p>}
        {meta && <div className="page-header-meta">{meta}</div>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
